var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"focus-toast"},[_c('span',[_vm._v(_vm._s(_vm.infoText))])])}
var staticRenderFns = []

export { render, staticRenderFns }